<ng-container *ngIf="difference">
  <span>{{ difference | number | tcNumberSign }}</span>
</ng-container>
